import axios from 'axios';

const instance = axios.create({
    headers: {
        'Content-Type': 'application/json',
    },
    transformRequest: [
        (data, headers) => {
            return JSON.stringify(data);
        },
    ],
});

// logout and redirect if response from server has status code 401
instance.interceptors.response.use(
    (response) => response,
    (error) => {
        return Promise.reject(error); // if error is returned, will be executed then branch
    }
);

// show error on
// - 400 - the frontend did something wrong, that user really can't fix
// - 403 - user is unauthorized and can do nothing about it
// - 500 - something on the server has failed
// - 503 - server is temporarily unavailable
instance.interceptors.response.use(
    (response) => response,
    (error) => {
        return Promise.reject(error); // if error is returned, will be executed then branch
    }
);

export default instance;
